import React, { useState, useEffect } from "react";
import axios from 'axios';
import { HiMiniUserGroup } from "react-icons/hi2";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { RiDeleteBin6Fill } from "react-icons/ri";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { RiRefund2Line } from "react-icons/ri";
import { MdOutlineCancel } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
function QuickHistory() {
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchQuick, setFetchQuick] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmRow, setConfirmRow] = useState(null);
  const [refundTxnId, setRefundTxnId] = useState("");
  const [showRefundInput, setShowRefundInput] = useState(false);
  const [cancelRow, setCancelRow] = useState(null);
  const [preStaff, setPreStaff] = useState([]);
  const [showStaffAllocateModal, setShowStaffAllocateModal] = useState(false);
  const [selectedServiceRow, setSelectedServiceRow] = useState(null);
  const [selectedStaffId, setSelectedStaffId] = useState("");
  const [serviceTypeFilter, setServiceTypeFilter] = useState("all");
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [formData, setFormData] = useState({
    id: "",
    service_time: ""
  });
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const fetchQuickService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-quick-service");
      setFetchQuick(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchQuickService();
  }, []);
  const filteredData = Array.isArray(fetchQuick) ? fetchQuick.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const parsedService = selectedRow?.service ? JSON.parse(selectedRow.service) : [];

  // let parsedAddress = [];

  // if (selectedRow?.address) {
  //   try {
  //     parsedAddress = JSON.parse(selectedRow.address);
  //   } catch {
  //     parsedAddress = [selectedRow.address];
  //   }
  // }

  let parsedAddress = null;
  if (selectedRow?.address) {
    try {
      parsedAddress = JSON.parse(selectedRow.address);
    } catch {
      parsedAddress = null;
    }
  }
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delete-quick-service-history/${id}`);
      showToast("Work slot deleted successfully", 'success');
      fetchQuickService();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete work slot", 'danger');
    }
  };
  const handleMarkPaid = async (row, refPayId, userId) => {
    try {
      const payload = {
        ref_pay_id: refPayId,
        user_id: userId
      };
      await axios.put(`https://api.sweepydo.in/refund-quick-serive/${row.id}`, payload);
      fetchQuickService();
      showToast("Service transaction refunded sucessfully!", 'success');
    } catch (error) {
      console.log(error);
      showToast("Fail to verify refund service transaction", 'danger');
    }
  };
  const handleCancelService = async row => {
    try {
      await axios.put(`https://api.sweepydo.in/cancel-quick-service/${row.id}`, {
        service_status: "Cancelled"
      });
      fetchQuickService();
      showToast("Service cancelled successfully!", "success");
    } catch (error) {
      console.log(error);
      showToast("Failed to cancel service", "danger");
    }
  };
  const fetchAttendance = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-present-staff");
      const data = res.data;
      setPreStaff(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAttendance();
  }, []);
  const handleAllocateStaff = async () => {
    try {
      await axios.put(`https://api.sweepydo.in/allocate-staff-for-service/${selectedServiceRow.id}`, {
        staff_id: selectedStaffId,
        user_id: selectedServiceRow.user_id
      });
      showToast("Staff allocated successfully!", "success");
      fetchQuickService();
      setShowStaffAllocateModal(false);
      setSelectedStaffId("");
      setSelectedServiceRow(null);
    } catch (error) {
      console.log(error);
      showToast("Failed to allocate staff", "danger");
    }
  };
  const formatDateTime = datetime => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };
  const handleEdit = async form => {
    setIsEditMode(true);
    setFormData({
      id: form.id,
      service_time: form.service_time || ""
    });
    setEditingCompanyId(form.id);
    setShowEditModal(true);
  };
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleUpdateServiceTime = async () => {
    try {
      const response = await axios.put(`https://api.sweepydo.in/update-service-time/${editingCompanyId}`, {
        service_time: formData.service_time
      });
      if (response.data.success) {
        showToast("Service time updated successfully");
        setShowEditModal(false);
        setIsEditMode(false);
        setEditingCompanyId(null);
      }
      fetchQuickService();
    } catch (error) {
      console.error("Update service time error:", error);
      showToast(error.response?.data?.message || "Failed to update service time");
    }
  };
  return <div className="container-fluid mt-3" style={{
    minHeight: "100vh"
  }}>

      <h2 className="mb-4 text-white text-center">Quick Service History</h2>

      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />

      <div className="card shadow-lg border-0 p-3" style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
        <div style={{
        background: "var(--black)",
        borderRadius: "12px",
        padding: "15px"
      }}>

          <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 py-4">


            <input type="text" className="form-control p-2" placeholder="Search by name ,number..." style={{
            background: "#1e293b",
            color: "#fff",
            border: "1px solid #334155",
            minWidth: "250px",
            width: "300px"
          }} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />


            <div className="d-flex gap-2">

              <select className="form-select" style={{
              background: "#1e293b",
              color: "#fff",
              border: "1px solid #334155",
              width: "180px"
            }} value={serviceTypeFilter} onChange={e => setServiceTypeFilter(e.target.value)}>
                <option value="all">All Services</option>
                <option value="Quick">Quick Service</option>
                <option value="Scheduled">Schedule Service</option>
              </select>

            </div>

          </div>

          <div className="table-responsive">
            <table className="text-center" style={{
            width: "100%",
            borderCollapse: "collapse",
            color: "#fff"
          }}>

              <thead>
                <tr style={{
                backgroundColor: "var(--black2)"
              }}>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}> ID</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER </th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}> MOBILE</th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}> STATUS</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>BOOKED ON</th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>STAFF </th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SCHEDULE ON  </th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ALLOCATED  </th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>COMPLETED/CANCELLED </th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ALLOCATED STAFF</th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ACTION</th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>CANCEL  </th>


                </tr>
              </thead>


              {filteredData.filter(s => {
              if (serviceTypeFilter === "all") return true;
              return s.service_type === serviceTypeFilter;
            }).map((s, idx) => <React.Fragment key={s.id}>
                    <tr style={{
                backgroundColor: "var(--black)",
                borderBottom: "1px solid rgba(255,255,255,0.06)",
                transition: "0.3s"
              }} onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = "var(--black2)";
              }} onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = "var(--black)";
              }} onClick={() => {
                setSelectedRow(s);
                setShowModal(true);
              }}>

                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>
                        {`${s.service_type === "Quick" ? "QS" : "SH"}ID${s.id}`}
                      </td>
                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.users_name}</td>

                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.users_mobile}</td>

                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.service_status}</td>
                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{formatDateTime(s.created_on)}</td>
                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}> {s.staff_name} </td>

                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.service_time} </td>
                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{formatDateTime(s.allot_on)} </td>
                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{formatDateTime(s.completed_on)} </td>

                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>
                        {(s.service_status === "Pending" || s.service_status === "Accepted") && <button className="btn btn-sm btn-success" onClick={e => {
                    e.stopPropagation();
                    setSelectedServiceRow(s);
                    fetchAttendance();
                    setShowStaffAllocateModal(true);
                  }}>
                            Select Staff
                          </button>}


                      </td>

                      <td style={{
                  textAlign: "center"
                }} className="d-flex justify-content-start gap-2 mt-4">

                        <RiDeleteBin6Fill size={26} cursor="pointer" title="Delete" className="mx-2 text-danger mt-2" onClick={e => {
                    e.stopPropagation();
                    showConfirmDialog({
                      title: "Delete work slot",
                      message: "Are you sure you want to delete this service ?",
                      onConfirm: () => handleDelete(s.id)
                    });
                  }} />

                          {s.service_type == "Scheduled" && <CiEdit size={26} cursor="pointer" title="Edit" className="mx-1 text-warning mt-2" onClick={e => {
                    e.stopPropagation();
                    handleEdit(s);
                  }} />}

                        {s.service_status === "Cancelled" && !s.ref_pay_id && <button className="btn btn-sm btn-primary" onClick={e => {
                    e.stopPropagation();
                    setConfirmRow(s);
                  }}>
                            Refund
                          </button>}

                        {s.ref_pay_id && <button className="btn btn-sm btn-success" disabled style={{
                    cursor: "not-allowed",
                    opacity: 0.7
                  }}>
                            Refunded
                          </button>}

                      </td>

                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>

                        {s.service_status != "Cancelled" && s.service_status != "Completed" && <MdOutlineCancel size={26} cursor="pointer" title="Cancel Service" className="mx-2 text-warning mt-2" onClick={e => {
                    e.stopPropagation();
                    setCancelRow(s);
                  }} />}


                      </td>

                    </tr>


                  </React.Fragment>)}

            </table>
          </div>
        </div>
        {showModal && selectedRow && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content" style={{
            backgroundColor: "var(--black)",
            color: "#fff",
            border: "1px solid #2d3748"
          }}>

                {/* Header */}
                <div className="modal-header">
                  <h5 className="modal-title">Service Details</h5>
                  <button className="btn-close " onClick={() => setShowModal(false)}> </button>
                </div>

                {/* Body */}
                <div className="modal-body bg-dark text-white">

                  {/* USER */}
                  <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                    <h6 className="text-info">User Details</h6>
                    <p><b>User:</b> {selectedRow.users_name}</p>
                    <p><b>Mobile:</b> {selectedRow.users_mobile}</p>
                  </div>

                  {/* CONTACT */}
                  <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                    <h6 className="text-secondary">Contact Details</h6>
                    <p><b>Contact Person:</b> {selectedRow.contact_name}</p>
                    <p><b>Contact No:</b> {selectedRow.contact_no}</p>
                  </div>

                  {/* SERVICE */}
                  <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                    <h6 className="text-info">Service Details</h6>
                    {parsedService.map((srv, i) => <div key={i}>
                        <p><b>Name:</b> {srv.name}</p>
                        <p><b>Price:</b> ₹{srv.sale_price}</p>
                        <p><b>Duration:</b> {srv.mins * 30} min</p>
                      </div>)}

                    <hr />
                    <p><b>Start OTP:</b> {selectedRow.start_otp}</p>
                    <p><b>End OTP:</b> {selectedRow.end_otp}</p>

                  </div>

                  <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                    <h6 className="text-secondary">Payment Details</h6>

                    <p><b>Amount:</b> ₹{selectedRow.amount}</p>
                    <p><b>Tax:</b> ₹{selectedRow.tax}</p>

                    {/* Platform Fee (if you have it) */}
                    <p>
                      <b>Platform Fee:</b> ₹{selectedRow.platform_fee || 0}
                    </p>

                    <p><b>Mode:</b> {selectedRow.pay_mode}</p>
                    <p><b>Payment ID:</b> {selectedRow.pay_id}</p>

                    <p>
                      <b>Status:</b>{" "}
                      <span className={selectedRow.pay_status?.toLowerCase().includes("success") ? "text-success fw-bold" : "text-danger fw-bold"}>
                        {selectedRow.pay_status}
                      </span>
                    </p>

                    <p><b>Received Date:</b> {selectedRow.receive_on}</p>
                    <p><b>Received Status:</b> {selectedRow.receive_status}</p>

                    {/* ✅ REFUND SECTION (CONDITIONAL) */}
                    {selectedRow.ref_pay_id && <div className="mt-3 p-2 border border-danger rounded" style={{
                  background: "rgba(220, 53, 69, 0.1)"
                }}>
                        <h6 className="text-danger">Refund Details</h6>

                        <p>
                          <b>Refunded Transaction ID:</b>{" "}
                          {selectedRow.ref_pay_id}
                        </p>

                        <p>
                          <b>Refunded Date:</b>{" "}
                          {selectedRow.ref_on}
                        </p>
                      </div>}
                  </div>

                  {/* ADDRESS */}
                  <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                    <h6 className="text-info">Address</h6>

                    {parsedAddress ? <>
                        <p>
                          {parsedAddress.name}
                          {parsedAddress.subLocality ? `, ${parsedAddress.subLocality}` : ""}
                        </p>
                        <p>
                          {parsedAddress.locality}, {parsedAddress.state}
                        </p>
                        <p>
                          {parsedAddress.country} - {parsedAddress.pincode}
                        </p>
                      </> : <p>{selectedRow?.address}</p>}
                  </div>

                  {/* STATUS */}
                  <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                    <h6 className="text-secondary">Service Status</h6>
                    <p><b>Status:</b> {selectedRow.service_status}</p>

                  </div>

                </div>

                {/* Footer */}
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                </div>

              </div>
            </div>
          </div>}



        {confirmRow && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-white border border-secondary">

                {/* Header */}
                <div className="modal-header">
                  <h5 className="modal-title text-warning">Refund Payment</h5>
                  <button className="btn-close btn-close-white" onClick={() => setConfirmRow(null)}></button>
                </div>

                {/* Body */}
                <div className="modal-body text-center">
                  <p>
                    Are you sure you want to refund the  transaction?
                  </p>

                  <p className="fw-bold text-info">
                    Service ID: QSID{confirmRow.id}
                  </p>
                </div>

                {/* Footer */}
                <div className="modal-footer justify-content-center">

                  <button className="btn btn-secondary" onClick={() => setConfirmRow(null)}>
                    Cancel
                  </button>

                  <button className="btn btn-success" onClick={() => {
                setShowRefundInput(true);
              }}>
                    Confirm
                  </button>
                </div>

              </div>
            </div>
          </div>}

        {showRefundInput && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-white">

                <div className="modal-header">
                  <h5 className="modal-title">Enter Refund Transaction ID</h5>
                  <button className="btn-close btn-close-white" onClick={() => {
                setShowRefundInput(false);
                setRefundTxnId("");
              }} />
                </div>

                <div className="modal-body">
                  <label className="form-label">Transaction ID</label>
                  <input type="text" className="form-control" value={refundTxnId} onChange={e => setRefundTxnId(e.target.value)} placeholder="Enter refund transaction ID" />
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => {
                setShowRefundInput(false);
                setRefundTxnId("");
              }}>
                    Cancel
                  </button>

                  <button className="btn btn-success" onClick={() => {
                handleMarkPaid(confirmRow, refundTxnId, confirmRow.user_id);
                setShowRefundInput(false);
                setConfirmRow(null);
                setRefundTxnId("");
              }} disabled={!refundTxnId.trim()}>
                    Submit
                  </button>
                </div>

              </div>
            </div>
          </div>}


        {cancelRow && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.65)",
        zIndex: 9999
      }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{
            background: "#1e1e1e",
            color: "#fff",
            borderRadius: "15px",
            border: "1px solid #444"
          }}>
                <div className="modal-header border-bottom border-secondary">
                  <h5 className="modal-title text-warning">
                    Cancel Service
                  </h5>

                  <button className="btn-close btn-close-white" onClick={() => setCancelRow(null)} />
                </div>

                <div className="modal-body text-center py-4">
                  <div style={{
                fontSize: "60px",
                color: "#ffc107"
              }}>
                    ⚠️
                  </div>

                  <h5 className="mt-3">
                    Are you sure?
                  </h5>

                  <p className="text-light mt-2">
                    You are about to cancel this service request.
                  </p>

                  <div className="alert alert-dark border border-warning mt-3">
                    <strong>Service ID:</strong>{" "}
                    QSID{cancelRow.id}
                  </div>
                </div>

                <div className="modal-footer border-top border-secondary justify-content-center">
                  <button className="btn btn-secondary px-4" onClick={() => setCancelRow(null)}>
                    No, Keep It
                  </button>

                  <button className="btn btn-danger px-4" onClick={() => {
                handleCancelService(cancelRow);
                setCancelRow(null);
              }}>
                    Yes, Cancel Service
                  </button>
                </div>
              </div>
            </div>
          </div>}


        {showStaffAllocateModal && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)",
        zIndex: 9999
      }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-white border border-secondary">

                <div className="modal-header">
                  <h5 className="modal-title text-success">
                    Allocate Staff
                  </h5>

                  <button className="btn-close btn-close-white" onClick={() => {
                setShowStaffAllocateModal(false);
                setSelectedStaffId("");
                setSelectedServiceRow(null);
              }} />
                </div>

                <div className="modal-body">

                  <p className="text-info">
                    Service ID: QSID{selectedServiceRow?.id}
                  </p>

                  <label className="form-label">
                    Select Staff Member
                  </label>

                  <select className="form-select" value={selectedStaffId} onChange={e => setSelectedStaffId(e.target.value)} style={{
                backgroundColor: "var(--black2)",
                color: "#fff",
                border: "1px solid #444"
              }}>
                    <option value="">Choose Staff</option>

                    {preStaff.map(staff => <option key={staff.id} value={staff.staff_id}>
                        {staff.staff_name}
                      </option>)}
                  </select>

                </div>

                <div className="modal-footer">

                  <button className="btn btn-secondary" onClick={() => {
                setShowStaffAllocateModal(false);
                setSelectedStaffId("");
                setSelectedServiceRow(null);
              }}>
                    Close
                  </button>

                  <button className="btn btn-success" disabled={!selectedStaffId} onClick={() => handleAllocateStaff()}>
                    Allocate Staff
                  </button>

                </div>

              </div>
            </div>
          </div>}



        {showEditModal && <div className="modal fade show" style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.75)"
      }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{
            backgroundColor: "#1e1e2f",
            color: "#fff",
            border: "1px solid #3a3a4a",
            borderRadius: "12px"
          }}>
                {/* HEADER */}
                <div className="modal-header" style={{
              borderBottom: "1px solid #3a3a4a"
            }}>
                  <h5 className="modal-title fw-semibold">
                    <CiEdit className="me-2 text-warning" size={24} />
                    Edit Service Time
                  </h5>

                  <button type="button" className="btn-close btn-close-white" onClick={() => {
                setShowEditModal(false);
                setIsEditMode(false);
              }}></button>
                </div>

                {/* BODY */}
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Service Time
                    </label>

                    <input type="time" name="service_time" value={formData.service_time} onChange={handleChange} className="form-control" style={{
                  backgroundColor: "#29293d",
                  color: "#fff",
                  border: "1px solid #4a4a5a"
                }} />
                  </div>
                </div>

                {/* FOOTER */}
                <div className="modal-footer" style={{
              borderTop: "1px solid #3a3a4a"
            }}>
                  <button type="button" className="btn btn-secondary" onClick={() => {
                setShowEditModal(false);
                setIsEditMode(false);
              }}>
                    Cancel
                  </button>

                  <button type="button" className="btn btn-warning" onClick={handleUpdateServiceTime}>
                    <CiEdit size={19} className="me-1" />
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>}

      </div>
      <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
      ...confirmDialog,
      show: false
    })} />
    </div>;
}
export default QuickHistory;
